<template>
  <div class="header" v-loading.fullscreen.lock="loading">
    <div class="header-box">
      <!--  发送方式-->
      <!-- <div class="row">
        <div class="label" style="font-weight: bold">
          {{ $t("message.sendingModeName") }}:
        </div>
        {{ detail.name }}
      </div> -->
      <!-- <div class="row">
        <div class="label" style="font-weight: bold">ID:</div>
        {{ detail.id }}
      </div> -->
      <!-- 物流logo -->
      <div class="row">
        <div class="label" style="font-weight: bold; line-height: 100px">
          {{ $t("message.logisticsName") }}: {{ detail.name }}
        </div>
        <div class="label" style="font-weight: bold; line-height: 100px">
          {{ $t("message.logisticsLogo") }}:
        </div>
        <div class="img">
          <img :src="detail.logo" alt="" v-if="detail.logo" />
          <div class="add" v-else></div>
          <div class="shade" v-if="isAuth(415)">
            <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <i class="el-icon-edit-outline"></i>
            </el-upload>
          </div>
        </div>

      </div>
      <!-- 实时生效元素设置： -->
      <div class="row">
        <div class="label" style="font-weight: bold">
          {{ $t("message.activeElementSettingsInRealTime") }}:
        </div>
        <!-- 物流方式状态： -->
        <div class="row">
          <div class="label">{{ $t("message.stateOfLogisticsMode") }}:</div>
          <el-switch v-model="detail.is_show" @change="logisticsIs_show" active-color="#2C96E7"
            :disabled="!isAuth(416)">
          </el-switch>
        </div>
        <!-- 物流单号自动获取： -->
        <div class="row">
          <div class="label">
            {{
    $t("message.theLogisticsTrackingNumberIsAutomaticallyObtained")
  }}:
          </div>
          <el-switch v-model="detail.is_auto_no" @change="logisticsSetIsAutoNo" active-color="#2C96E7"
            :disabled="!isAuth(418)">
          </el-switch>
        </div>
        <!-- 物流单号可用数量 -->
        <div class="row">
          <div class="label">
            {{ $t("message.availableQuantityOfLogisticsTrackingNumber") }}:
          </div>
          {{ detail.number_count_unused }}
          <!-- 号段设置 -->
          <el-button type="primary" style="margin-left: 20px" @click="setThemRoughly" size="mini" class="primary"
            v-if="isAuth(419)">{{
    $t("message.setThemRoughly") }}</el-button>
          <span style="margin-left: 10px; font-size: 12px">( {{ $t("message.carousel1") }})</span>
        </div>
        <!-- 客户订单选择提示： -->
        <div class="row">
          <div class="label">
            {{ $t("message.customerOrderSelectionPrompt") }}:
          </div>
          <!-- 提示语设置 -->
          <el-button size="small" type="primary" @click="promptDialogVisible = true" class="primary"
            v-if="isAuth(417)">{{
    $t("message.promptMessageSetting") }}</el-button>
          <span style="margin-left: 10px; font-size: 12px">( {{ $t("message.carousel1") }})</span>
        </div>
        <!-- 是否VIP可使用 -->
        <div class="row">
          <div class="label">
            是否VIP可使用:
          </div>

          <el-switch v-model="detail.is_vip" @change="is_vip" active-color="#2C96E7">
          </el-switch>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="btn">
      <!-- 删除改方式 -->
      <el-button size="small" type="primary" class="dark" @click="logisticsDelete" v-if="isAuth(413)">
        {{ $t("message.deleteChangeMode") }}
      </el-button>
    </div>

    <!-- 物流单号自动获取设置： -->
    <el-dialog :title="$t('message.setTheLogisticsTrackingNumberAutomatically')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="808px" center>
      <div class="box">
        <!-- 号段规则：-->
        <div class="row">
          <div class="label">{{ $t("message.themRoughlyRules") }}：</div>
          <div class="val">
            <!-- 前缀 -->
            <div class="qian">
              <el-input v-model="auto_no_rule.prefix" size="small" :placeholder="$t('message.prefix')"></el-input>
            </div>
            <!-- 开始单号 -->
            <div class="input">
              <el-input v-model="auto_no_rule.start" size="small"
                :placeholder="$t('message.startSingleNumber')"></el-input>
            </div>
            <!-- 截止单号 -->
            <div class="input">
              <el-input v-model="auto_no_rule.end" size="small" :placeholder="$t('message.singleNumber')"></el-input>
            </div>
          </div>
        </div>
        <!-- 已使用：-->
        <div class="row">
          <div class="label">{{ $t("message.hasBeenUsed") }}：</div>
          <div class="val">{{ detail.number_count_used }}</div>
        </div>
        <!-- 可用数量：：-->
        <div class="row">
          <div class="label">{{ $t("message.availableQuantity") }}：</div>
          <div class="val">{{ detail.number_count_unused }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="logisticsSetAutoNoRule">{{
    $t("message.save")
  }}</el-button>
      </span>
    </el-dialog>
    <!-- 提示语设置： -->
    <el-dialog :title="$t('message.promptMessageSetting')" :close-on-click-modal="false"
      :visible.sync="promptDialogVisible" width="536px" center>
      <div class="box">
        <el-input type="textarea" :rows="9" placeholder="请输入新增的物流方式的名称" v-model="detail.tips">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="logisticsUpdateTips">{{
          $t("message.save")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  computed: {

  },
  data() {
    return {
      dialogVisible: false,
      promptDialogVisible: false,
      loading: false,
      auto_no_rule: {
        prefix: "", start: "", end: "", length: 0
      },
    };
  },
  methods: {
    // 上传成功
    handleAvatarSuccess(res, file) {
      this.detail.logo = res.data;
      this.logisticsUpdateLogo();
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";

      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
    // 修改物流logo
    logisticsUpdateLogo() {
      let datas = {
        logistics_id: this.$route.query.id,
        logo: this.detail.logo,
      };
      this.$api.siteConfiguration.logisticsUpdateLogo(datas).then((res) => {
        this.$message.success(res.msg);
        this.loading = false;
      });
    },
    // 单号自动生成开关
    logisticsIs_show() {
      let datas = {
        logistics_id: this.$route.query.id,
        is_show: this.detail.is_show ? 1 : 0,
      };
      this.$api.siteConfiguration.logisticsIs_show(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    // 单号自动生成开关
    logisticsSetIsAutoNo() {
      let datas = {
        logistics_id: this.$route.query.id,
        is_auto_no: this.detail.is_auto_no ? 1 : 0,
      };
      this.$api.siteConfiguration.logisticsSetIsAutoNo(datas).then((res) => {
        if (res.code != 0) {
          this.detail.is_auto_no = false;
          return false;
        }
        this.$message.success(res.msg);
      });
    },
    // 单号自动生成开关
    is_vip() {
      let datas = {
        logistics_id: this.$route.query.id,
        is_vip: this.detail.is_vip ? 1 : 0,
      };
      this.$api.siteConfiguration.is_vip(datas).then((res) => {
        if (res.code != 0) {
          this.detail.is_vip = false;
          return false;
        }
        this.$message.success(res.msg);
      });
    },
    // 物流单号自动获取设置
    logisticsSetAutoNoRule() {
      let datas = {
        logistics_id: this.$route.query.id,
        prefix: this.auto_no_rule.prefix,
        start: this.auto_no_rule.start,
        end: this.auto_no_rule.end,
      };
      this.$api.siteConfiguration.logisticsSetAutoNoRule(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.logisticsDetail();
      });
    },
    // 提示语设置
    logisticsUpdateTips() {
      let datas = {
        logistics_id: this.$route.query.id,
        tips: this.detail.tips,
      };
      this.$api.siteConfiguration.logisticsUpdateTips(datas).then((res) => {
        if (res.code != 0) {
          return false;
        }
        this.promptDialogVisible = false;
        this.$message.success(res.msg);
      });
    },
    // 删除
    logisticsDelete() {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration
            .logisticsDelete({ logistics_id: this.$route.query.id })
            .then((res) => {
              this.$message.success(res.msg);
              setInterval(() => {
                window.close();
              }, 2000);
            });
        })
        .catch(() => { });
    },
    //
    setThemRoughly() {
      if (this.detail.auto_no_rule) {
        this.auto_no_rule = this.detail.auto_no_rule
      }
      this.dialogVisible = true
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  padding: 24px;
  margin: 24px;
  background-color: #f8f8f8;
  border-radius: 8px;

  .header-box {
    .row {
      margin-bottom: 10px;
      display: flex;
      flex-wrap: wrap;
      line-height: 32px;
      margin-right: 80px;

      .label {
        width: 120px;
        margin-right: 20px;
        text-align: right;
      }

      .img {
        cursor: pointer;
        position: relative;

        .add {
          border-radius: 4px;
          border: 1px solid #ccc;
          width: 100px;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }

        &:hover {
          .shade {
            display: block;
          }
        }

        img {
          width: 100px;
          height: 100px;
        }

        .shade {
          position: absolute;
          top: 0;
          left: 0;
          width: 100px;
          height: 100px;
          background: rgba(0, 0, 0, 0.3);
          text-align: right;
          display: none;

          i {
            cursor: pointer;
            font-size: 20px;
            color: #b4272d;
            display: inline-block;
            margin: 5px;
          }
        }
      }

      /deep/.el-switch {
        margin-top: 10px;
      }
    }
  }

  //   min-width: 1862px;
}

.box {
  padding: 20px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .row {
    margin-bottom: 20px;
    display: flex;
    line-height: 32px;

    .label {
      flex: 1;
    }

    .val {
      flex: 4;
      display: flex;

      .qian {
        flex: 1;
      }

      .input {
        flex: 2;
        margin-left: 20px;
      }
    }
  }
}
</style>